import React from "react";

const PurchaseInvoiceChargeGrid = ({
  charges = [],
  setCharges,
  isDraft = false
}) => {
    const handleChargeChange = (
    index,
    field,
    value
    ) => {

    const updated = [...charges];

    updated[index] = {
        ...updated[index],
        [field]: value
    };

    const amount = Number(
        updated[index].charge_amount || 0
    );

    const gstRate = Number(
        updated[index].gst_rate || 0
    );

    updated[index].gst_amount =
        (amount * gstRate) / 100;

    updated[index].total_amount =
        amount +
        updated[index].gst_amount;

    setCharges(updated);
    };

  return (
    <div className="pi-card">

      <div className="pi-card-title">
        Additional Charges
      </div>

      <div className="pi-grid-wrapper">

        <table className="pi-line-table">

          <thead>
            <tr>
              <th>Charge Type</th>
              <th>Charge Amount</th>
              <th>GST %</th>
              <th>GST Amount</th>
                <th>Total</th>
              <th>PO</th>
            </tr>
          </thead>

          <tbody>

            {charges.length === 0 && (
              <tr>
                <td
                  colSpan="6"
                  className="pi-no-data"
                >
                  No charges available
                </td>
              </tr>
            )}

            {charges.map((charge, index) => (
              <tr
                key={charge.po_charge_id}
              >
                <td>
                  {charge.charge_type}
                </td>

                <td>
                    {isDraft ? (
                        <input
                        type="number"
                        step="0.01"
                        value={
                            charge.charge_amount || 0
                        }
                        onChange={(e) =>
                            handleChargeChange(
                            index,
                            "charge_amount",
                            e.target.value
                            )
                        }
                        className="form-control form-control-sm"
                        />
                    ) : (
                        Number(
                        charge.charge_amount || 0
                        ).toFixed(2)
                    )}
                    </td>

                <td>
                    {isDraft ? (
                        <input
                        type="number"
                        step="0.01"
                        value={
                            charge.gst_rate || 0
                        }
                        onChange={(e) =>
                            handleChargeChange(
                            index,
                            "gst_rate",
                            e.target.value
                            )
                        }
                        className="form-control form-control-sm"
                        />
                    ) : (
                        Number(
                        charge.gst_rate || 0
                        ).toFixed(2)
                    )}
                    </td>

                    <td>
                    {Number(
                        charge.gst_amount || 0
                    ).toFixed(2)}
                    </td>

                    <td>
                    {Number(
                        charge.total_amount || 0
                    ).toFixed(2)}
                    </td>

                    <td>
                    {charge.po_id}
                    </td>
              </tr>
            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default PurchaseInvoiceChargeGrid;